module.exports = __webpack_public_path__ + "media/cuu/sec_educacion_deporte_cuu-a904c90e.jpg";